import { CheckCheck, UserCheck, UsersRound } from "lucide-react";

import { ChoiceCardOption } from "@/components/campos-formulario/novos/ChoiceCards";
import {
  ModoEtapaAprovacao,
  ModoEtapaAprovacaoMap,
  RoleLabelsMap,
  RoleNome,
} from "@workflow/types";

/** Opções de cargo (multi-select) — todos os cargos do sistema com rótulo humano. */
export const cargoOptions: { value: string; label: string }[] = Object.entries(RoleLabelsMap)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));

/** Rótulo humano de um cargo (cai no próprio código se for desconhecido). */
export const cargoLabel = (cargo: string): string => RoleLabelsMap[cargo as RoleNome] ?? cargo;

/**
 * Cartões de escolha do modo da etapa. O título carrega a consequência (o que
 * acontece ao escolher), não o termo técnico — padrão do ChoiceCards.
 */
export const modoOptions: ChoiceCardOption<ModoEtapaAprovacao>[] = [
  {
    value: ModoEtapaAprovacao.TODOS,
    title: ModoEtapaAprovacaoMap[ModoEtapaAprovacao.TODOS],
    description: "A etapa só fecha quando todas as pessoas dos cargos abaixo aprovarem.",
    icon: <CheckCheck className="size-5" />,
  },
  {
    value: ModoEtapaAprovacao.UM_POR_CARGO,
    title: ModoEtapaAprovacaoMap[ModoEtapaAprovacao.UM_POR_CARGO],
    description: "A etapa fecha quando pelo menos uma pessoa de cada cargo aprovar.",
    icon: <UsersRound className="size-5" />,
  },
  {
    value: ModoEtapaAprovacao.QUALQUER,
    title: ModoEtapaAprovacaoMap[ModoEtapaAprovacao.QUALQUER],
    description: "Basta uma pessoa, de qualquer cargo, aprovar para a etapa fechar.",
    icon: <UserCheck className="size-5" />,
  },
];
